import React from 'react';

import {IconTitles} from "../../components/iconTitle";
import {faCalendarAlt, faCheck, faQuestion, faTerminal, faTimes} from "@fortawesome/pro-solid-svg-icons";
import LabelToggle from "../../components/labelToggle";
import DivTable from "../../components/divTable";
import {Get, Post} from "../../components/request";
import screens from "../../screens";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MyToggle from "../../components/myToggle";
import {toast} from 'react-toastify'
import {withRouter} from "react-router-dom";
import ScreenComponent from "../../components/screenComponent";


class Examens extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            session: {},
            examens: []
        };
    }

    async componentDidMount() {
        super.componentDidMount();

        let {body} = await Get(`/v1/extranet/student/${screens.Examens}`);

        this.setState({
            session: body
        });

        this.toggleInscription.setState({
            disabled: body.InscriptionSessionValide,
        });

        if (body.InscriptionSessionValide) {
            this.toggleInscription.setState({
                checked: body.InscriptionSessionValide,
            });

            ({body} = await Get(`/v1/extranet/student/${screens.Examens}01`));

            this.setState({
                examens: body
            }, () => {
                this.state.examens.forEach((item) => {
                    item.ref.setState({
                        checked: item.ResultatEtudiantInscrit,
                        disabled: item.ResultatEtudiantInscrit
                    })
                })
            });
        }
    }

    updateCheckedExamens(elm) {
        elm.ref.setState({
            checked: !elm.ResultatEtudiantInscrit
        }, () => {
            elm.hasBeenModified = true;
            elm.ResultatEtudiantInscrit = !elm.ResultatEtudiantInscrit;
        })
    }

    async updateInscription(elm) {
        if (elm === this.toggleInscription && this.toggleInscription.state.checked) {
            this.toggleInscription.setState({disabled: true});
            await Post(`/v1/extranet/student/inscriptionSession/${this.state.session.SessionID}`);
            this.componentDidMount();
        }
    }

    async postExamens() {
        const inscrit = this.state.examens.filter((item) => item.ResultatEtudiantInscrit);
        const modified = this.state.examens.filter((item) => item.hasBeenModified);
        const modIns = modified.filter((item) => item.ResultatEtudiantInscrit);

        if (inscrit.length <= 0) {
            return toast.warning("Veuillez faire au moins une sélection!");
        } else if (modified <= 0) {
            return toast.info("Vous n'avez effectué aucune modification depuis la dernière sauvegarde!");
        }

        modIns.forEach((item) => {
            item.ref.setState({disabled: true});
            delete item.ref;
        });

        await Post(`/v1/extranet/student/inscriptionExamens`, modIns, "Sauvegarde en cours..", {
            render: <><FontAwesomeIcon className="mr-2" icon={faCheck}/>L'inscription est validée !</>
        }, {
            render: <><FontAwesomeIcon className="mr-2" icon={faTimes}/>Impossible de valider l'inscription.</>
        }, {
            render: <><FontAwesomeIcon className="mr-2" icon={faQuestion}/>Vous êtes déjà inscrit à tous les examens de
                la session.</>
        });

        this.componentDidMount();
    }

    render() {
        return (
            <>
                <section>
                    <IconTitles titles={[
                        {icon: faTerminal, content: this.state.session.NiveauCoursLibelle},
                        {icon: faCalendarAlt, content: this.state.session.SessionNomComplet},
                    ]}/>
                    <hr/>
                </section>
                <section>
                    <LabelToggle ref={(r) => this.toggleInscription = r}
                                 onChange={this.updateInscription.bind(this)}
                                 required={true}
                                 label="Inscription à la session d'examen"/>
                </section>
                {
                    this.state.session.InscriptionSessionValide ?
                        <>
                            <section>
                                <div style={{margin: "0 1rem 1rem"}}>
                                    <small>Sélectionnez les activités d'apprentissage pour lesquelles vous souhaitez
                                        présenter l’examen lors de la session, ainsi que celles pour lesquelles une
                                        évaluation est prévue au cours de ce quadrimestre et dont vous attendez les
                                        résultats.</small>
                                </div>
                                <DivTable columns={{
                                    "Sélection": (item) => {
                                        return (
                                            <div className="p-1 d-flex justify-content-center align-items-center">
                                                <MyToggle ref={(r) => item.ref = r}
                                                          onChange={this.updateCheckedExamens.bind(this, item)}
                                                          disabled={item.ResultatEtudiantInscrit}
                                                />
                                            </div>
                                        );
                                    }, "Code": "Code", "Activite d'apprentissage ou Cours Erasmus": "Libelle"
                                }}
                                          array={this.state.examens}
                                />
                                <Button onClick={this.postExamens.bind(this)} className={"my-4"} size="lg"
                                        variant={"success"} block>Valider mon inscription</Button>
                            </section>
                        </>
                        : ""
                }

            </>
        );
    }
}

export default withRouter(Examens);